import React, { useEffect, useState } from 'react';
import './App.css';


function App() {
  const [flag, setFlag] = useState('')

  useEffect(() => {
    const check = async () => {
      const req = await fetch(`https://geo.codeite.app/?r=${Math.random()}`)
      const json = await req.json()
      console.log({json})

      const emoji = json?.location?.country_flag_emoji
      setFlag(emoji)
    }

    const handle = setInterval(check, 1000)
    check()

    return () => {
      clearInterval(handle)
    }

  })


  return (
    <div className="App">
      {flag}
    </div>
  );
}

export default App;
